TS.ns('WL');

WL.documentVerificationViewModel = new Class({
    Extends: TS.domain.EditDomain,

    createProperties: function (config) {
        var me = this;

        me.parent(config);

        partner = me.getDomainProperty('browsePartner_Property');
        
        if (partner != null) {
            partner.on('selectionChanged', me.onPartnerChanged, me);
        }

        var item = me.getDomainProperty('browseItem_Property');
        if (item != null) {
            item.on('selectionChanged', me.onItemChanged, me);
        }
    },

    onPartnerChanged: function (selectedPartner) {
        var me = this,
            partnerId,
            partnerName,
            partnerTypeId,
            partnerTypeName;

        if (selectedPartner.record == null) {
            partnerName = '';
        }
        else {
            me.PartnerId(selectedPartner.record.PartnerId);
            me.PartnerName(selectedPartner.record.PartnerName);
            me.PartnerDisplayName(selectedPartner.record.PartnerName + ' / ' + selectedPartner.record.PartnerTypeName + ' / ' + selectedPartner.record.UniqueID);
            me.PartnerTypeId(selectedPartner.record.PartnerTypeId);
            me.PartnerUniqueId(selectedPartner.record.UniqueID);
        }

        me.performServerCommand({
            cmd: 'changeSelectedPartner',
            submitModel: true,
            blockUI: true
        });
    },

    onItemChanged: function (selectedItem) {
        var me = this,
            itemId,
            itemName;

        if (selectedItem.record == null) {
            itemName = '';
        }
        else {
            me.ItemId(selectedItem.record.ItemId);
            me.ItemName(selectedItem.record.ItemName);
            me.ItemDisplayName(selectedItem.record.ItemCode + ' / ' + selectedItem.record.ItemName);
            me.ItemUniqueId(selectedItem.record.ItemUniqueId);
        }

        me.performServerCommand({
            cmd: 'changeSelectedItem',
            submitModel: true,
            blockUI: true
        });
    }
});